"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _receipt = require("@/api/receipt/receipt");
var _yearOptions = _interopRequireDefault(require("@/libs/yearOptions"));
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _marketing = require("@/api/marketing");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'receiptInfo',
  components: {
    merchantName: _merchantName.default
  },
  data: function data() {
    return {
      activeNames: [],
      timeVal: [],
      activeName: '1',
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      OffId: [],
      receiptHeaderData: [],
      receiptTakerData: [],
      multipleSelection: [],
      tableFrom: {
        page: 1,
        limit: 20,
        dateLimit: '',
        type: 1,
        receiptHeadId: null,
        receiptTakerId: null
      },
      fromList: this.$constants.fromList,
      dialogVisible: false,
      dialogTakerVisible: false,
      dialogDetailVisible: false,
      accountDetails: {},
      pickerOptions: this.$timeOptions,
      pickerOptionsYear: _yearOptions.default,
      selReceiptHeader: null,
      selReceiptTaker: null,
      receiptAmount: 0,
      receiptData: {}
    };
  },
  mounted: function mounted() {
    this.getList(1);
    this.getReceiptHeaderList();
  },
  methods: {
    handleDetailReceipt: function handleDetailReceipt(data) {
      this.receiptData = data;
      this.dialogDetailVisible = true;
    },
    handleDetailClose: function handleDetailClose() {
      this.dialogDetailVisible = false;
    },
    selectReceiptHeader: function selectReceiptHeader(data) {
      this.selReceiptHeader = data;
      console.log(data);
      this.dialogVisible = false;
    },
    selectReceiptTaker: function selectReceiptTaker(data) {
      this.selReceiptTaker = data;
      console.log(this.selReceiptTaker);
      this.dialogTakerVisible = false;
    },
    // 批量卡票
    batchReceipt: function batchReceipt() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择开票订单');
      this.handleReceipt(this.OffId);
    },
    //取消开票
    handleCancelReceipt: function handleCancelReceipt(id) {
      var _this2 = this;
      this.$modalSure('确定取消开票吗').then(function () {
        (0, _receipt.cancelReceiptInfo)({
          id: id
        }).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '提交成功'
          });
          _this2.getList(1);
        });
      });
    },
    // 全部开票
    handleAllReceipt: function handleAllReceipt() {
      var _this3 = this;
      this.$modalSure('确定开票吗').then(function () {
        if (!_this3.selReceiptHeader) {
          _this3.$message.error('请选择发票头信息');
          _this3.$msgbox.close();
          return;
        }
        if (!_this3.selReceiptTaker) {
          _this3.$message.error('请选择发票收件人信息');
          _this3.$msgbox.close();
          return;
        }
        _this3.tableFrom.type = _this3.activeName;
        _this3.tableFrom.receiptHeadId = _this3.selReceiptHeader.id;
        _this3.tableFrom.receiptTakerId = _this3.selReceiptTaker.id;
        console.log(_this3.tableFrom);
        (0, _receipt.receiptAllInfoInitApi)(_this3.tableFrom).then(function (res) {
          _this3.$message({
            type: 'success',
            message: '提交成功'
          });
          _this3.getList(1);
        });
      });
    },
    // 选择开票
    handleReceipt: function handleReceipt(id) {
      var _this4 = this;
      this.$modalSure('确定开票吗').then(function () {
        if (!_this4.selReceiptHeader) {
          _this4.$message.error('请选择发票头信息');
          _this4.$msgbox.close();
          return;
        }
        if (!_this4.selReceiptTaker) {
          _this4.$message.error('请选择发票收件人信息');
          _this4.$msgbox.close();
          return;
        }
        (0, _receipt.receiptInfoInitApi)({
          orderNOList: id.toString(),
          receiptHeadId: _this4.selReceiptHeader.id,
          receiptTakerId: _this4.selReceiptTaker.id
        }).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '提交成功'
          });
          _this4.getList(1);
        });
      });
    },
    /**
     *  增加发票收件人
     */
    handleReceiptTaker: function handleReceiptTaker(row) {
      var _this = this;
      this.$modalParserFrom('发票收件人信息', '发票收件人', 1, {}, function (formValue) {
        _this.takerSubmit(formValue);
      }, this.keyNum += 1);
    },
    //表单提交
    takerSubmit: function takerSubmit(formValue) {
      var _this5 = this;
      var data = {
        taker: formValue.takerName,
        takerTel: formValue.takerTel,
        takerAddress: formValue.takerAddress,
        email: formValue.email
      };
      (0, _receipt.receiptTakerInitApi)(data).then(function (res) {
        _this5.$message.success('操作成功');
        _this5.$msgbox.close();
        _this5.getReceiptTakerList();
      }).catch(function () {
        _this5.loading = false;
      });
    },
    getReceiptTakerList: function getReceiptTakerList() {
      var _this6 = this;
      (0, _receipt.receiptTakerByListApi)().then(function (res) {
        _this6.receiptTakerData = res;
      }).catch(function () {
        _this6.loading = false;
      });
    },
    /**
     *  增加发票头
     */
    handleReceiptHeader: function handleReceiptHeader(row) {
      var _this = this;
      this.$modalParserFrom('发票头信息', '发票头信息添加', 1, {}, function (formValue) {
        console.log(formValue);
        _this.submit(formValue);
      }, this.keyNum += 1);
    },
    //表单提交
    submit: function submit(formValue) {
      var _this7 = this;
      var data = {
        companyName: formValue.companyName,
        creditCode: formValue.creditCode,
        address: formValue.address,
        tel: formValue.tel,
        bank: formValue.bank,
        bankAccount: formValue.bankAccount
      };
      (0, _receipt.receiptHeaderInitApi)(data).then(function (res) {
        _this7.$message.success('操作成功');
        _this7.$msgbox.close();
        _this7.getReceiptHeaderList();
      }).catch(function () {
        _this7.loading = false;
      });
    },
    getReceiptHeaderList: function getReceiptHeaderList() {
      var _this8 = this;
      (0, _receipt.ReceiptHeaderByListApi)().then(function (res) {
        _this8.receiptHeaderData = res;
      }).catch(function () {
        _this8.loading = false;
      });
    },
    removeReceiptHeader: function removeReceiptHeader(data) {
      var _this9 = this;
      var par = {
        id: data
      };
      (0, _receipt.deleteReceiptHeaderApi)(par).then(function (res) {
        _this9.$message.success('操作成功');
        _this9.$msgbox.close();
        _this9.getReceiptHeaderList();
      }).catch(function () {
        _this9.loading = false;
      });
    },
    removeReceiptTaker: function removeReceiptTaker(data) {
      var _this0 = this;
      var par = {
        id: data
      };
      (0, _receipt.deleteReceiptTakerApi)(par).then(function (res) {
        _this0.$message.success('操作成功');
        _this0.$msgbox.close();
        _this0.getReceiptTakerList();
      }).catch(function () {
        _this0.loading = false;
      });
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList(1);
    },
    handleClick: function handleClick() {
      console.log(this.activeName);
      this.tableFrom.dateLimit = '';
      this.timeVal = [];
      this.getList(1);
    },
    onDetails: function onDetails() {
      this.dialogVisible = true;
      console.log(this.receiptHeaderData);
    },
    onTakerDetails: function onTakerDetails() {
      this.dialogTakerVisible = true;
      this.getReceiptTakerList();
    },
    seachList: function seachList() {
      this.handleClose();
      this.getList(1);
    },
    // 列表
    getList: function getList(num) {
      var _this1 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.type = this.activeName;
      (0, _receipt.receiptList)(this.tableFrom).then(function (res) {
        console.log(res);
        _this1.tableData.data = res.list;
        _this1.tableData.total = res.total;
        _this1.listLoading = false;
      }).catch(function () {
        _this1.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList(1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleTakerClose: function handleTakerClose() {
      this.dialogTakerVisible = false;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this10 = this;
      this.multipleSelection = val;
      var data = [];
      this.receiptAmount = 0;
      this.multipleSelection.map(function (item) {
        data.push(item.subDistributionOrderId);
        _this10.receiptAmount += item.vipPrice;
      });
      this.receiptAmount = this.receiptAmount > 0 ? this.receiptAmount.replace(/\b(0+)/gi, '') : 0;
      this.OffId = data;
    }
  }
};